<template>
    <div :class="$style['transaction-css']">
        <div :class="$style['transactionProfile']">
            <div v-if="dataUser != null && dataUser.length == 0" style="margin-top: 80%">
                <div :class="$style['contentTransaction']">
                    <v-icon>search_off</v-icon>
                    <span>تراکنشی انجام نشده است</span>
                </div>
            </div>
            <div style="width: 100%; display: flex; flex-direction: column">
                <v-card
                        :class="$style['subscriptionCard']"
                        v-for="item in dataUser"
                        :key="item.index">
                    <v-card-title>
                        <h5>{{ item.payment_description }}</h5>
                    </v-card-title>
                    <span>
                <span v-if="item.payment_type == 0" :class="$style['increase']">{{
                  oracle.format(item.payment_amount)
                }}</span>
                <span v-else :class="$style['minus']">{{
                  oracle.format(item.payment_amount)
                }}</span>
                تومان</span
                    >
                    <v-card-subtitle>
                        <div :class="$style['dateCard']">
                            <span>{{oracle.formatDate(item.create_at)}}</span>
                        </div>
                    </v-card-subtitle>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "Transactions",
        data: () => ({
            dataUser: null,
            oracle: oracle,
        }),
        methods: {
            getTransactions(res) {
                this.dataUser = res.data;
            },
            getProfile(res) {
                this.profile = res.data;
            },
        },
        mounted() {
            oracle.axios("payment/getTransactions", {"limit_by": 500, "offset_by": 0}, this.getTransactions);
            oracle.axios("user/getProfile", null, this.getProfile);
        },
    };
</script>
<style module>
    .transaction-css .imageHeader {
        background-color: #7ec352;
        height: 200px;
        width: 100%;
        margin-top: -60px;
    }

    .transaction-css .imageHeader img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        z-index: 1;
        opacity: 0.2;
    }

    .increase {
        margin-right: 15px;
        color: #7ec352 !important;
    }

    .minus {
        margin-right: 15px;
        color: red !important;
    }

    .transaction-css .headertransaction {
        position: relative;
        left: 0;
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-items: center;
        margin-top: -60px;
        margin-bottom: 5px;
    }

    .transaction-css .headerProfile {
        background-color: #7ec352;
        width: 100%;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
    }

    .transaction-css .headerProfile img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        z-index: 1;
        opacity: 0.2;
    }

    .transaction-css .transactionCredit {
        /* margin-top: -110px; */
        margin-bottom: 2em;
        color: #fff;
    }

    .transaction-css .transactionCredit p {
        margin: 0;
        font-size: 14px;
    }

    .transaction-css .transactionCredit span {
        color: #ffdb02;
        padding: 0 10px;
    }

    .transaction-css .headerDetail {
        position: relative;
        margin-bottom: 1em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .transaction-css .IncreaseCredit {
        color: #fff;
        font-size: 13px;
    }

    .transaction-css .IncreaseCredit .v-icon {
        color: #ffdb02;
        padding: 0 10px;
    }

    .transaction-css .contentTransaction i {
        color: #7ec352;
        font-size: 5em;
        margin: 0 auto;
    }

    .transaction-css .contentTransaction span {
        font-size: 13px;
    }

    .transaction-css .contentTransaction {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
    }

    .transaction-css .contentTransaction .v-icon {
        font-size: 4em;
    }

    .transaction-css .contentTransaction span {
        font-size: 12px;
    }

    .transaction-css .transactionProfile {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        height: 90%;
        position: relative;
    }

    .transaction-css {
        background-color: #fff;
        height: 100%;
    }

    .transaction-css .headerTop-basket {
        background: #4b4a4a;
        padding: 15px 10px;
        display: flex;
        /*border-bottom: 4px solid #ffea6b;*/
    }

    .transaction-css .headline {
        display: flex;
        justify-content: space-between;
        padding: 10px;
    }

    .transaction-css .headline span {
        font-size: 15px !important;
        font-weight: bold;
    }

    .transaction-css .backpage,
    .transaction-css .backpage .v-icon {
        color: #cad5d1;
        font-size: 15px;
    }

    .transaction-css .backpage .v-icon {
        font-size: 27px;
    }

    .transaction-css .backpage span {
        font-size: 12px !important;
    }

    .transaction-css .priceText {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        font-size: 12px;
    }

    .transaction-css .priceText span:last-child {
        color: #ffdb02;
    }

    .transaction-css .btnAddprice button {
        margin: 15px 0;
    }

    .transaction-css .btn-accept {
        width: 80%;
        height: 35px;
        font-size: 12px;
    }

    .transaction-css .v-text-field label {
        font-size: 12px;
    }

    .transaction-css .subscriptionCard {
        padding: 10px;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
    }

    .transaction-css .v-card__title {
        font-size: 13px !important;
        display: flex;
        justify-content: space-between;
    }

    .transaction-css .v-card__title h5 {
        font-size: 15px;
        padding-left: 15px;
    }

    .transaction-css .v-card__title span {
        color: #008080;
        font-weight: bold;
    }

    .transaction-css .v-card__subtitle {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
    }

    .transaction-css .dateCard {
    }

    .transaction-css .item-credit {
        text-align: left;
    }

    .transaction-css .item-credit button {
        margin-bottom: 70px;
        position: fixed;
        bottom: 0;
        left: 25px;
        border-radius: 20px;
        background-color: #7ec352 !important;
        color: white !important;
    }

    .transaction-css .CardSubscription {
        width: 100%;
        overflow: auto;
        height: 80%;
        padding: 20px;
    }
</style>
